export default __webpack_public_path__ + "static/media/enviro 1.6 ratio.1e1bd1fe.png";